import { moveBox } from "../../../../common/actions";

/**
 * alignBoxes — aligns selected boxes by dispatching MOVE_BOX for each.
 * Uses DOM getBoundingClientRect for pixel-accurate positioning.
 *
 * @param {"left"|"right"|"top"|"bottom"|"centerH"|"centerV"|"center"} type
 * @param {string[]} ids
 * @param {object} boxes      — Redux boxes map id → box
 * @param {object} toolbars   — unused, reserved for future
 * @param {Function} dispatch
 */
export function alignBoxes(type, ids, boxes, toolbars, dispatch) {
  const container =
    document.getElementById("maincontent") || document.getElementById("contained_maincontent");
  if (!container) return;

  const cw = container.offsetWidth;
  const ch = container.offsetHeight;
  const containerRect = container.getBoundingClientRect();

  const rects = ids
    .map((id) => {
      const el = document.getElementById("box-" + id);
      if (!el) return null;
      const br = el.getBoundingClientRect();
      return {
        id,
        el,
        left: br.left - containerRect.left,
        top: br.top - containerRect.top,
        right: br.right - containerRect.left,
        bottom: br.bottom - containerRect.top,
        width: br.width,
        height: br.height,
      };
    })
    .filter(Boolean);

  if (rects.length === 0) return;

  const anchorLeft = Math.min(...rects.map((r) => r.left));
  const anchorRight = Math.max(...rects.map((r) => r.right));
  const anchorTop = Math.min(...rects.map((r) => r.top));
  const anchorBottom = Math.max(...rects.map((r) => r.bottom));
  const anchorCenterV = rects.reduce((s, r) => s + (r.left + r.right) / 2, 0) / rects.length;
  const anchorCenterH = rects.reduce((s, r) => s + (r.top + r.bottom) / 2, 0) / rects.length;
  // "center" anchors to the MIDDLE element (not the average): sort the
  // horizontal centers and take the median — with an even count, the average
  // of the two middle ones. The align toolbar disables it below 3 elements.
  const sortedCenters = rects.map((r) => (r.left + r.right) / 2).sort((a, b) => a - b);
  const mid = sortedCenters.length >> 1;
  const anchorMiddle =
    sortedCenters.length % 2 === 1
      ? sortedCenters[mid]
      : (sortedCenters[mid - 1] + sortedCenters[mid]) / 2;

  rects.forEach(({ id, el, left, top, width, height }) => {
    const box = boxes[id];
    if (!box) return;

    let newLeft = left;
    let newTop = top;

    switch (type) {
      case "left":
        newLeft = anchorLeft;
        break;
      case "right":
        newLeft = anchorRight - width;
        break;
      case "top":
        newTop = anchorTop;
        break;
      case "bottom":
        newTop = anchorBottom - height;
        break;
      case "centerV":
        newLeft = anchorCenterV - width / 2;
        break;
      case "center":
        newLeft = anchorMiddle - width / 2;
        break;
      case "centerH":
        newTop = anchorCenterH - height / 2;
        break;
      default:
        return;
    }

    const xPct = (newLeft / cw) * 100 + "%";
    const yPct = (newTop / ch) * 100 + "%";

    el.style.left = xPct;
    el.style.top = yPct;

    dispatch(moveBox(id, xPct, yPct, box.position.type, box.parent, box.container));
  });
}
